module.exports = __webpack_public_path__ + "img/help.9fbfe9ad.svg";